import { staticSelector } from 'ducks/static'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import {
  Container,
  Content,
  Title,
  CardDesign,
  Left,
  LeftIconContainer,
  Icon,
  TextContainer,
  Info,
  Vector,
  Right,
  RightIconContainer,
  InfoGrey,
  InfoGreen,
} from '../styledCard'
import vector from 'assets/Vector6.png'
import { Metric } from '../../MetricsPage/types'

interface Props {
  data: Metric
}

export const Card4: FC<Props> = ({ data }) => {
  const state = useSelector(staticSelector)

  const { title, iconLeft, iconRight, textLeft, textRight } = state.content?.nationalMetric.subTabRender[3]

  return (
    <Container>
      <Content>
        {/* {title ? <Title>{title}</Title> : null} */}
        <CardDesign>
          <Left>
            <LeftIconContainer leftColor="#38BBE5">
              {iconLeft.url ? <Icon src={iconLeft.url} /> : null}
            </LeftIconContainer>
            <TextContainer>
              <>
                <Info>
                  <InfoGrey leftColor="#38BBE5">{data.water} gallons of water</InfoGrey>
                  Total $ savings of <InfoGrey leftColor="#38BBE5">${data.water_money}.</InfoGrey>
                </Info>
              </>
            </TextContainer>
          </Left>
          <Vector src={vector} />
          <Right>
            <RightIconContainer rightColor="#54AE2A">
              {iconRight.url ? <Icon src={iconRight.url} /> : null}
            </RightIconContainer>
            <TextContainer>
              <Info>
                That’s the equivalent of <InfoGreen>{data.water_visual} bathtubs</InfoGreen> of fresh drinking water
              </Info>
            </TextContainer>
          </Right>
        </CardDesign>
      </Content>
    </Container>
  )
}
